import { Component } from "react";
import Box from '@mui/material/Box';
import HelpText from "./HelpText";
import RecoverPasswordForm from "./form/RecoverPasswordForm";
import FormHeader from "../../../../components/FormHeader";

type Props = {};

type State = {
}

export default class RecoverPasswordFirst extends Component<Props, State> {

  componentDidMount() {
    document.body.classList.add("grey-background");
  }

  componentWillUnmount() {
    window.location.reload();
    document.body.classList.remove("grey-background");
  }

  render() {
    return (
      <Box>
        <FormHeader title='Recuperar contraseña'></FormHeader>
        <HelpText></HelpText>
        <RecoverPasswordForm></RecoverPasswordForm>
      </Box>
    );
  }
}